/**************************
* Entry point for main.js *
**************************/

// load modules
import Navigation from './navigation';
import ImgToBackground from './ImgToBackground';
import HeroHeight from './heroHeight';
import GlideSlider from './glide-slider';
import VimeoVideo from './vimeo-video';
import MainSlider from './main-slider';
import DocumentSlider from './document-slider';
import JobPageOutput from './jobPageOutput';
import JobFocusLabels from './jobFocusLabels';
import JumpToRequired from './jumpToRequired';
import LazyLoadVideos from './lazy-load-videos';

// instantiate objects
const heroHeight = new HeroHeight();
const slider = new GlideSlider();

// init modules
const imgToBgd = ImgToBackground( jQuery );

// DOM ready calls
jQuery( function( $ ) {

  // init navigation module
  const navigation = new Navigation( $ );
  navigation.init();
  // init HeroHeight module
  heroHeight.changeHeight();
  // init glideSlider module
  slider.setUpGlide();
  // init VimeoVideo module
  const vimeoVideo = new VimeoVideo();
  vimeoVideo.init();
  // init mainSlider
  const mainSlider = new MainSlider( $ );
  mainSlider.init();
  // init documentSlider
  const documentSlider = new DocumentSlider( $ );
  documentSlider.init();
  // load Job Page related scripts
  JobPageOutput();
  JobFocusLabels($);
  JumpToRequired($);
  // init lazyLoadVideos
  const lazyLoadVideos = new LazyLoadVideos($);
  lazyLoadVideos.init();

});


/*#######################
### Window load event ###
#######################*/

jQuery( window ).load(function () {
  imgToBgd.makeImgBackground( '.js-image-imgtobg', '.js-background-imgtobg' );
});


/*#######################
### Window resize event ###
#######################*/

jQuery( window ).resize(function () {
  // call changeHeight method
  heroHeight.changeHeight();
  // call setUpGlide metod
  slider.setUpGlide();
});
